'use strict';

export default class message {
    constructor(options) {
        this.opt = options;
        this.bindHandlers();
    }

    bindHandlers() {
        let _self = this;

        message.scroll();

        _self.opt.messageSendBtn.click(function () {
            _self.send();
        });

        // if press 'Enter' key
        _self.opt.messageTextArea.keypress((e) => {
            if (e.which === 13) {
                e.preventDefault();
                _self.send();
            }
        });

        //vacancy block
        $('.vacancy-list li').each(function () {
            $(this).on('click', function () {
                $('.vacancy-list').css('display', 'none');
            });
        });

        $('.choose-vacancy').on('click', function () {
            $('.vacancy-list').css('display', 'block');
        });

        $('.chat-vacancy-chose').click(function () {
            $('a.vacancy-name').remove();
            let li = $(this);
            let wrapper = $('div.chat-chosen-vacancy');

            $('<a>', {
                text: li.attr('data-vacancy-name'),
                class: li.attr('data-class') + ' vacancy-name',
                target: '_blanc',
                href: li.attr('data-path'),
            }).attr('data-vacancy-id', li.attr('data-vacancy-id')).prependTo(wrapper);

            $('.empty-vacancy').remove();
        });
        //vacancy block
    }

    send() {
        let error = $('#message-error');
        let errorVacancy = $('#message-error-no-vacancy');
        if (errorVacancy.length > 0) {
            error.css('display', 'none');
            errorVacancy.css('display', 'none');
        }

        let _this = $(this);
        let messageBody = this.opt.messageTextArea.val();
        let vacancyId = $('.vacancy-name').attr('data-vacancy-id');
        //dont touch it - its magic
        if ($('.chat-chosen-vacancy a').hasClass('no-active') && errorVacancy.length > 0 ||
            (null === this.opt.vacancyId && 'undefined' === typeof vacancyId)
        ) {
            errorVacancy.css('display', 'block');
            message.scroll('.message-error', 550);
            return false;
        }

        if (messageBody !== '') {

            if (messageBody.length > 2000) {
                error.css('display', 'flex');
                return false;
            }

            _this.attr('disabled', true);
            this.opt.messageTextArea.val('');

            let newMessage = $(this.opt.template).hide();
            this.opt.chatBody.append(newMessage);

            $('.chat-text span').last().prepend(this.cleanMessage(messageBody));
            newMessage.slideDown();

            $.post('/api/v1/message', {
                body: messageBody,
                to: this.opt.recipientId,
                invite: false,
                vacancyId: vacancyId ? vacancyId : this.opt.vacancyId
            })
                .done(function () {
                    _this.attr('disabled', false);

                }).fail(function ($xhr) {
                var data = $xhr.responseJSON;

                $.each(data.fields_errors, function (key, errorText) {
                    console.info(errorText);
                });
            });

            message.scroll(this.opt.messageTextArea, 550);
        }
    }

    cleanMessage(text) {
        text = text.replace('<script>', '');
        return text.replace('</script>', '');
    }

    static scroll() {
        $('html,body').animate({
            scrollTop: $('.input-field').offset().top - 300
        }, 'slow');
    }
}

